function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.38706 0.580651L6.27614 0.43934C5.7955 -0.101386 5.03919 -0.14298 4.51613 0.314557L4.39052 0.43934L0.390524 4.93934L0.335328 5.00528L0.261779 5.10704L0.166228 5.27391L0.0949673 5.443L0.0477935 5.60101L0.00920955 5.82286L0 6L0.00371715 6.11286L0.0269868 6.30109L0.0663175 6.46821L0.124898 6.63483L0.194661 6.78106L0.292918 6.93817L0.390524 7.06066L4.39052 11.5607C4.91122 12.1464 5.75544 12.1464 6.27614 11.5607C6.75679 11.0199 6.79376 10.1691 6.38706 9.58065L6.27614 9.43934L4.55333 7.5H14.6667C15.403 7.5 16 6.82843 16 6C16 5.17157 15.403 4.5 14.6667 4.5H4.55333L6.27614 2.56066C6.75679 2.01993 6.79376 1.16909 6.38706 0.580651L6.27614 0.43934L6.38706 0.580651Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.38706 0.580651L6.27614 0.43934C5.7955 -0.101386 5.03919 -0.14298 4.51613 0.314557L4.39052 0.43934L0.390524 4.93934L0.335328 5.00528L0.261779 5.10704L0.166228 5.27391L0.0949673 5.443L0.0477935 5.60101L0.00920955 5.82286L0 6L0.00371715 6.11286L0.0269868 6.30109L0.0663175 6.46821L0.124898 6.63483L0.194661 6.78106L0.292918 6.93817L0.390524 7.06066L4.39052 11.5607C4.91122 12.1464 5.75544 12.1464 6.27614 11.5607C6.75679 11.0199 6.79376 10.1691 6.38706 9.58065L6.27614 9.43934L4.55333 7.5H14.6667C15.403 7.5 16 6.82843 16 6C16 5.17157 15.403 4.5 14.6667 4.5H4.55333L6.27614 2.56066C6.75679 2.01993 6.79376 1.16909 6.38706 0.580651L6.27614 0.43934L6.38706 0.580651Z",
  fill: "url(#paint0_linear)"
});

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 8,
  y1: 0,
  x2: 8,
  y2: 12,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0
})));

var SvgArrowIcon = function SvgArrowIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrowIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow-icon.b7b582b8.svg";
export { ForwardRef as ReactComponent };